import { Link } from "react-router-dom";
import type { Drama } from "@/types/drama";

interface DramaCardProps {
  drama: Drama;
  showProgress?: boolean;
}

export default function DramaCard({ drama, showProgress = true }: DramaCardProps) {
  return (
    <Link
      to={`/detail/${drama.id}`}
      className="group relative flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
        <img
          src={drama.cover}
          alt={`${drama.title} 剧集封面`}
          title={`${drama.title} 电视剧剧照`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-500/90 px-2 py-0.5 text-[11px] font-medium text-background-50">
          {drama.status}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-black/55 px-2 py-0.5 text-[11px] font-medium text-background-50">
          <i className="ri-star-fill text-accent-400"></i>
          {drama.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 translate-y-full bg-foreground-950/80 p-3 text-[11px] leading-relaxed text-background-100 transition-transform duration-300 group-hover:translate-y-0">
          <p className="line-clamp-3">{drama.synopsis}</p>
        </div>
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
          {drama.title}
        </h3>
        <p className="mt-1 line-clamp-1 text-xs text-foreground-500">主演：{drama.cast.slice(0, 3).join(" / ")}</p>
        {showProgress && (
          <div className="mt-2 flex items-center justify-between text-[11px] text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-play-circle-line"></i>
              更新至 {drama.updatedEpisodes}/{drama.totalEpisodes} 集
            </span>
            <span>{drama.updateTime.slice(5)}</span>
          </div>
        )}
      </div>
    </Link>
  );
}